/* eslint-disable consistent-return */
import { PageContainer } from 'app/components/ui/page-container';
import { useBuilding } from 'app/shared/contexts/building';
import { Building } from 'app/data/types/building';
import { TenantContentData } from 'app/data/types/content';
import { ContentView } from './content-view';
import { ErrorPage } from 'app/pages/error';
import { useContent } from 'app/shared/contexts/content';
import { ContentLoading } from 'app/components/content-loading';
import { useRef } from 'react';
import { useMobileScreen } from 'app/shared/hooks/use-mobile-screen';
import { useMicroFrontendParams } from 'app/shared/hooks/use-micro-frontend-params';

export const ContentPage = (): JSX.Element => {
  const { content, isLoading, isError } = useContent();
  const { building } = useBuilding();
  const { isMobileScreen } = useMobileScreen();
  const getParams = useMicroFrontendParams();
  const hasRedirected = useRef(false);

  const serviceRedirectUrl = content?.navigation_command?.options?.url;
  const shouldRedirect = !isLoading && !!content?.attachable_service_uuid && !!serviceRedirectUrl;

  if (shouldRedirect && !hasRedirected.current) {
    hasRedirected.current = true;
    window.location.replace(`${serviceRedirectUrl}?${getParams}&isFromContent=true`);
  }

  if (isError) {
    return <ErrorPage />;
  }

  // Terminal empty state: the query settled (not loading, not an error, not redirecting)
  // but there's no content — e.g. a deleted/invalid content uuid returning an empty-but-
  // valid response. Without this the loading guard below (`!content`) would spin forever.
  if (!isLoading && !shouldRedirect && !content) {
    return <ErrorPage />;
  }

  // Content-load gating (and hiding the native header) is handled once, up in
  // AppContentWrapper's aggregate loading gate, so content is present by the time we
  // render. The spinner here only covers the redirect-to-service window.
  const isLoadingOrRedirecting = isLoading || shouldRedirect;

  return (
    <PageContainer isLoading={isLoadingOrRedirecting}>
      {isLoadingOrRedirecting
      ? <ContentLoading />
      : <ContentView content={content as TenantContentData} building={building as Building | null} isMobile={isMobileScreen} />}
    </PageContainer>
  );
};
